<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10.93 13.62l2.79-1.61-2.79-1.62v3.23z"/><path d="M19 4H5a1 1 0 00-1 1v13.32A1.68 1.68 0 005.68 20h12.64A1.68 1.68 0 0020 18.32V5a1 1 0 00-1-1zm-1.85 10.59a1.31 1.31 0 01-.95.95 31.4 31.4 0 01-4.2.23 31.4 31.4 0 01-4.2-.23 1.32 1.32 0 01-1-.95A13.7 13.7 0 016.62 12a13.56 13.56 0 01.23-2.58 1.35 1.35 0 011-1A32.81 32.81 0 0112 8.24a32.81 32.81 0 014.2.22 1.34 1.34 0 01.95 1 13.56 13.56 0 01.23 2.54 13.7 13.7 0 01-.23 2.59z"/></svg>